"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FactSchema = void 0;
exports.FactSchema = {
    "$id": "https://www.redbull.com/schemas/attributes/fact.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "Fact",
    "description": "Fact",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "attributes:fact"
            ]
        },
        "fact": {
            "$ref": "https://www.redbull.com/schemas/attributes/textual-artefact-container.schema.json"
        },
        "factAbout": {
            "$ref": "https://www.redbull.com/schemas/attributes/text.schema.json"
        }
    },
    "required": [
        "fact",
        "factAbout",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZmFjdC5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbW9kdWxlcy9hdHRyaWJ1dGVzL2ZhY3Quc2NoZW1hLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEsVUFBVSxHQUFHO0lBQ3hCLEtBQUssRUFBRSw2REFBNkQ7SUFDcEUsU0FBUyxFQUFFLDhDQUE4QztJQUN6RCxPQUFPLEVBQUUsTUFBTTtJQUNmLGFBQWEsRUFBRSxNQUFNO0lBQ3JCLE1BQU0sRUFBRSxRQUFRO0lBQ2hCLHNCQUFzQixFQUFFLEtBQUs7SUFDN0IsWUFBWSxFQUFFO1FBQ1osTUFBTSxFQUFFO1lBQ04sTUFBTSxFQUFFLFFBQVE7WUFDaEIsTUFBTSxFQUFFO2dCQUNOLGlCQUFpQjthQUNsQjtTQUNGO1FBQ0QsTUFBTSxFQUFFO1lBQ04sTUFBTSxFQUFFLG1GQUFtRjtTQUM1RjtRQUNELFdBQVcsRUFBRTtZQUNYLE1BQU0sRUFBRSw2REFBNkQ7U0FDdEU7S0FDRjtJQUNELFVBQVUsRUFBRTtRQUNWLE1BQU07UUFDTixXQUFXO1FBQ1gsTUFBTTtLQUNQO0NBQ0YsQ0FBQSJ9